import { render, staticRenderFns } from "./QueryShinTapir.vue?vue&type=template&id=13f9d980&scoped=true&"
import script from "./QueryShinTapir.vue?vue&type=script&lang=js&"
export * from "./QueryShinTapir.vue?vue&type=script&lang=js&"
import style0 from "./QueryShinTapir.vue?vue&type=style&index=0&id=13f9d980&lang=scss&scoped=true&"
import style1 from "./QueryShinTapir.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f9d980",
  null
  
)

export default component.exports